/** The "Nabble_" wordmark: the logo when no logo image has been uploaded. */
export function Wordmark({ className }: { className?: string }): React.JSX.Element {
  return (
    <span className={`nb-wordmark-text${className ? ` ${className}` : ""}`} aria-label="Nabble">
      Nabble<b>_</b>
    </span>
  );
}
